<template>
  <QPaginatedSearchDropdown :value="value" :list-getter="getDepartmentListFromFilter" :filter="filter"
    :min-search-char-limit="0" :externaledit="externaledit" :clearable="clearable" :multiple="multiple"
    :returnobject="returnobject" :disabled="disabled" :loading="loading" valuekey="Id" textkey="Name"
    :label="label ? label : $t('servicesystem.common_objects.department.department')" :singleline="singleline"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.department.search_field_label')"
    @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">

    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">$department</v-icon>
    </template>

    <template v-slot:append-outer>
      <slot name="append-outer" />
    </template>

  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "DepartmentSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    hideIcon: Boolean,
    singleline: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>